import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "personal-center-banner" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static.wecity.qq.com/miying/aigame-banner-868550c300fb2ab0e4ffd91b07545f15.png",
  alt: "",
  class: "personal-center-banner__img"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "t-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "personal-center-banner__title" }, "“觅影”医学人工智能算法大赛"),
  /*#__PURE__*/_createElementVNode("div", { class: "personal-center-banner__subtitle" }, "Tencent AIMIS")
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}